export enum SecondaryCloud {
  Beta = 'Beta',
  OpenSync = 'OpenSync',
  Dogfood = 'Dogfood',
}
